module.exports = __webpack_public_path__ + "img/ewm18.9ed7a38e.jpg";